// extracted by mini-css-extract-plugin
module.exports = {"selectType":"styleBayan_selectType__2kadb"};